import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import {
  Button,
  Modal,
} from 'advenio-components'

import CreditCardPreview from '../CreditCardPreview'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 16px;
`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: flex-end;
  flex: 1;
  margin-top: 32px;
`
const Message = styled.div`
  margin-top: 16px;
`

const ActivateModal = ({
  card,
  loading,
  isSmallScreen,
  onActivate,
  onClose,
  onDelete,
  isOpen,
  parent,
  student,
  willDelete,
}) => {
  const getTitle = () => {
    if (willDelete) return '¿Eliminar Tarjeta?'

    if (isSmallScreen) return '¿Utilizar por default?'

    return '¿Utilizar tarjeta por default?'
  }

  return (
    <Modal
      isOpened={isOpen}
      onClose={onClose}
      headerTitle={getTitle()}
      statePath="cards"
      actionType="activate"
      typePrefix="CARDS"
      smallHeader={isSmallScreen}
    >
      <Container>
        {parent &&
        <CreditCardPreview card={card} parentName={`${parent.first_name} ${parent.last_name_paternal}`} />
        }
        {!willDelete ? (<Message>
          ¿Estás seguro que deseas utilizar por default esta tarjeta para uso de <b>{`${student.first_name} ${student.last_name_paternal}`}</b>?
        </Message>) : (<Message>
          ¿Estás seguro que deseas eliminar esta tarjeta por completo? Ninguno de los hijos del tutor podrá seguir utilizando esta tarjeta.
        </Message>)}

        <ButtonsContainer>
          <Button
            ghost
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button
            primary={!willDelete}
            danger={willDelete}
            loading={loading}
            onClick={!willDelete ? onActivate : onDelete}
          >
            {!willDelete ? 'Usar por Default' : 'Eliminar Tarjeta'}
          </Button>
        </ButtonsContainer>
      </Container>
    </Modal>
  )
}

ActivateModal.propTypes = {
  /** The credit card being authorized/deauthorized */
  card: PropTypes.object,
  /** Indicates whether the modal is being displayed isSmallScreen-screen on a mobile device */
  isSmallScreen: PropTypes.bool,
  /** Indicates whether the modal should be displayed or hidden */
  isOpen: PropTypes.bool,
  /** Indicates whether an API call is in progress */
  loading: PropTypes.bool,
  /** The active parent */
  parent: PropTypes.object.isRequired,
  /** The active student */
  student: PropTypes.object.isRequired,
  /** Indicates whether a credit card is to be deleted */
  willDelete: PropTypes.bool,

  /** Callback function to be fired when activating the specified credit card */
  onActivate: PropTypes.func.isRequired,
  /** Callback function to be fired when closing the modal */
  onClose: PropTypes.func.isRequired,
  /** Callback function to be fired when deleting the specified credit card */
  onDelete: PropTypes.func.isRequired,
}

ActivateModal.defaultProps = {
  isOpen: false,
  isSmallScreen: false,
  loading: false,
  willDelete: false,
}

export default ActivateModal



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/ActivateCardModal.jsx